module.exports = __webpack_public_path__ + "img/inktober_2020_26_hide.324263aa.jpg";